var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-55-document-text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.328,
    height: 77.203,
    viewBox: "0 0 54.328 77.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document-text",
    d: "M41.313,3H12.743A5.741,5.741,0,0,0,7,8.74V74.464a5.719,5.719,0,0,0,5.711,5.74H55.617a5.705,5.705,0,0,0,5.711-5.711V25.875H47.048a5.71,5.71,0,0,1-5.736-5.713V3Zm2.859,0V20.148A2.864,2.864,0,0,0,47,23.016H61.328L44.172,3ZM15.578,23.016v2.859H35.594V23.016Zm0-8.578V17.3H35.594V14.438Zm0,17.156v2.859H52.75V31.594Zm0,8.578v2.859H52.75V40.172Zm0,8.578v2.859H52.75V48.75Zm0,8.578v2.859H52.75V57.328Zm0,8.578v2.859H52.75V65.906Z",
    transform: "translate(-7 -3)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowreview);
export default __webpack_public_path__ + "static/media/flowreview.1cc5d857fb3d5d952540b918b171a799.svg";
export { ForwardRef as ReactComponent };